import React from 'react';
import Button from './Button';

const LookingForSupport = () => {
  return (
    <section id="support" className="relative py-10 md:py-14 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-10">
          {/* Left: support image */}
          <div className="flex-shrink-0 order-2 lg:order-1">
            <img
              src="/images/Support Image.png"
              alt="Young person looking for community support"
              loading="lazy"
              className="w-96 sm:w-[27rem] md:w-[30rem] h-auto object-contain"
            />
          </div>

          {/* Right: content */}
          <div className="flex-1 text-center lg:text-left order-1 lg:order-2">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-ifys-blue mb-4 md:mb-6 tracking-tight">
              Looking for support?
            </h2>
            <p className="text-gray-700 text-base md:text-lg leading-relaxed mb-6 md:mb-8 max-w-2xl mx-auto lg:mx-0">
              If you or a loved one are looking for support, IFYS provides a range of services that can help. You can get started by calling our main phone line at 07 5438 3000.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                href="/services/ifys-services"
                variant="primary"
                size="lg"
              >
                Learn More
              </Button>
              <Button
                href="tel:+61754383000"
                variant="secondary"
                size="lg"
                className="gap-2"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                </svg>
                Call 07 5438 3000
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LookingForSupport;
